/**
 * ConvictionChangesThisWeek — Strategy Insights section 3.
 * Joins kb_conviction_history (last 7 days) with kb_items.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@/components/ui/badge';
import { DS_COLORS, DS_SPACING, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { copy } from '@/content/copy';
import { SectionRegenWrap } from '@/components/strategy-insights/SectionRegenWrap';
import { ROUTES } from '@/config/product-contract';

const STATUS_LABEL = copy.kb.conviction.labels;

export function ConvictionChangesThisWeek({ changes = [], onResynth }) {
  return (
    <SectionRegenWrap title={copy.strategyInsights.sections.convictionChanges} onResynth={onResynth}>
      {changes.length === 0 ? (
        <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.secondary, margin: 0 }}>
          {copy.strategyInsights.empty.convictionChanges}
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: DS_SPACING.cardGap }}>
          {changes.map((c) => (
            <div
              key={c.change_id}
              data-regen-key={c.change_id}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: DS_SPACING.labelToContent / 2,
                padding: DS_SPACING.cardPadding / 2,
                background: DS_COLORS.surface.white,
                border: `1px solid ${DS_COLORS.border.default}`,
                borderRadius: 8,
              }}
            >
              <a
                href={`${ROUTES.KNOWLEDGE_BASE}?id=${c.kb_item_id}`}
                style={{ ...DS_TYPOGRAPHY.listItemTitle, color: DS_COLORS.text.primary, textDecoration: 'none' }}
              >
                {c.title}
              </a>
              <div style={{ display: 'flex', alignItems: 'center', gap: DS_SPACING.buttonGap }}>
                <Badge variant="outline">{STATUS_LABEL[c.prev_status] || '—'}</Badge>
                <span style={{ color: DS_COLORS.text.muted }}>→</span>
                <Badge>{STATUS_LABEL[c.new_status] || '—'}</Badge>
              </div>
              {c.reason && (
                <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.secondary, margin: 0 }}>
                  {c.reason}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </SectionRegenWrap>
  );
}

ConvictionChangesThisWeek.propTypes = {
  changes: PropTypes.array,
  onResynth: PropTypes.func,
};

export default ConvictionChangesThisWeek;
